<template>
    <div class="document">
        <Policy v-if="$route.name === 'policy'" />
        <Agree v-if="$route.name === 'agree'" />
    </div>
</template>
<script>
export default {
    name: 'Document',
    components: {
        Policy: () => import('@/components/Documents/Policy'),
        Agree: () => import('@/components/Documents/Agree')
    }
}
</script>
<style lang="stylus">
    .document
        width 100%
        padding 60px 0
        overflow auto
        .wrap
            max-width 800px
        
        h1
            font-size 32px
            font-weight 600
            line-height 40px
            padding-bottom 20px
        h2
            font-size 24px
            font-weight 600
            line-height 30px
            padding-bottom 14px
            margin-top 20px
        
        h4
            font-size 18px
            font-weight 600
            line-height 24px
            padding-bottom 14px
            margin-top 20px
        
        p
            font-size 16px
            font-weight 400
            line-height 24px
            padding-bottom 14px
        
        ul
            li
                font-size 16px
                font-weight 400
                line-height 24px
                padding-bottom 14px
</style>